import React, { useCallback, useState } from "react";

import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import { Button, Modal } from "@mapmycustomers/ui";

import Checkbox from "@app/component/input/Checkbox";
import layout from "@app/styles/layout";

import styles from "./DeleteActivitiesConfirmationModal.module.scss";

interface Props {
  loading: boolean;
  onConfirm: (dontShowAgain: boolean) => void;
  onHide: () => void;
}

const DeleteActivitiesConfirmationModal: React.FC<Props> = ({ loading, onConfirm, onHide }) => {
  const intl = useIntl();
  const [dontShowAgain, setDontShowAgain] = useState<boolean>(false);
  const handleConfirm = useCallback(() => {
    onConfirm(dontShowAgain);
  }, [dontShowAgain, onConfirm]);

  return (
    <Modal
      footer={null}
      onCancel={onHide}
      title={intl.formatMessage({
        id: "activity.listView.deleteConfirmModal",
        defaultMessage: "Repeating activities selected",
        description: "Confirmation modal for deleting recurring activities - title",
      })}
      visible
    >
      <div className={styles.container}>
        <p className={styles.description}>
          {intl.formatMessage(
            {
              id: "activity.listView.deleteConfirmModal.description",
              defaultMessage:
                "You’ve attempted to delete some activities that are set to repeat. Please note that only the selected activity instance will be deleted.{br}{br}Future instances of those activities will be preserved.",
              description: "Confirmation modal for deleting recurring activities - description",
            },
            {
              br: <br />,
            }
          )}
        </p>
        <Row align="middle" justify="space-between">
          <Col>
            <Checkbox checked={dontShowAgain} onChange={setDontShowAgain}>
              {intl.formatMessage({
                id: "activity.listView.deleteConfirmModal.dontShowAgain",
                defaultMessage: "Don’t show again",
                description:
                  "Confirmation modal for deleting recurring activities - don't show again text",
              })}
            </Checkbox>
          </Col>
          <Col>
            <Row gutter={layout.spacerM}>
              <Col>
                <Button onClick={onHide} type="default">
                  {intl.formatMessage({
                    id: "activity.listView.deleteConfirmModal.cancel",
                    defaultMessage: "Cancel",
                    description:
                      "Confirmation modal for deleting recurring activities - cancel button label",
                  })}
                </Button>
              </Col>
              <Col>
                <Button loading={loading} onClick={handleConfirm} type="primary">
                  {intl.formatMessage({
                    id: "activity.listView.deleteConfirmModal.proceed",
                    defaultMessage: "Proceed",
                    description:
                      "Confirmation modal for deleting recurring activities - proceed button label",
                  })}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default DeleteActivitiesConfirmationModal;
